import React from "react";
import "./index.scss";
import img from "../../../assets/images/equipe.png"; // Assurez-vous que le chemin est correct
export const Equipe = () => {
  return (
    <div className="equipe mt-5">
      {" "}
      <div className="row ms-0 justify-content-center  gx-0 w-100 align-items-center mb-5">
        <div className="col-12 col-md-6 mx-auto d-flex justify-content-center align-items-center">
          <img src={img} alt="equipe" className="img-fluid" />
        </div>
        <div className="col-12 col-md-6 mx-auto ">
          <div className="equipe-title">
            Une équipe à<br /> votre écoute
          </div>
          <div className="equipe-text">
            Nos techniciens, chefs de chantiers et conducteurs de travaux sont
            formés pour vous <br className="d-none d-md-block" />
            conseiller, coordonner les travaux et assurer un suivi transparent
            du début à la fin.
          </div>
        </div>
      </div>
    </div>
  );
};
